query ListPurchaseOrderTags($id: UUID!) {
  purchaseOrder(id: $id) {
    id
    entityTagsByEntityId {
      nodes {
        id
        _isDeletable
        _tagBadgeName
        _tagBadgeColor
        _createdDate
        createdByUser
        _rowTimestamp
      }
    }
  }
}
